import { render } from "./QuestionEditor.vue?vue&type=template&id=e8cc5fc0&scoped=true"
import script from "./QuestionEditor.vue?vue&type=script&lang=js"
export * from "./QuestionEditor.vue?vue&type=script&lang=js"

import "./QuestionEditor.vue?vue&type=style&index=0&id=e8cc5fc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8cc5fc0"]])

export default __exports__